import { c as _c } from "react/compiler-runtime";
import { ActionWorldCardSkeleton } from '@/components/ActionWorldCard';
import { useIsClient } from 'usehooks-ts';
type MyWorldsSkeletonProps = {
  count: number;
  className?: string;
};
export default function MyWorldsSkeleton(t0) {
  const $ = _c(5);
  const {
    count,
    className
  } = t0;
  const isClient = useIsClient();
  if (!isClient) {
    return null;
  }
  let skeletonCount;
  if (window.innerWidth >= 1800) {
    skeletonCount = 10 - count % 10 + 10 - 1;
  } else {
    if (window.innerWidth >= 1280) {
      skeletonCount = 8 - count % 8 + 8 - 1;
    } else {
      if (window.innerWidth >= 1024) {
        skeletonCount = 6 - count % 3 + 6 - 1;
      } else {
        skeletonCount = 0;
      }
    }
  }
  let t1;
  if ($[0] !== className || $[1] !== skeletonCount) {
    let t2;
    if ($[3] !== className) {
      t2 = (_, index) => <ActionWorldCardSkeleton key={index} className={className} />;
      $[3] = className;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = Array(skeletonCount).fill(null).map(t2);
    $[0] = className;
    $[1] = skeletonCount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}